var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLinkUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 79,
    viewBox: "0 0 94 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M36.0432 6.35548C35.6606 6.16417 35.4693 6.06851 35.2686 6.03087C35.0909 5.99752 34.9085 5.99752 34.7308 6.03087C34.5301 6.06851 34.3388 6.16417 33.9562 6.35548L5.83301 20.4171L33.9562 34.4786C34.3388 34.67 34.5301 34.7656 34.7308 34.8033C34.9085 34.8366 35.0909 34.8366 35.2686 34.8033C35.4693 34.7656 35.6606 34.67 36.0432 34.4786L64.1663 20.4171L36.0432 6.35548Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 34.9999L33.9562 49.0615C34.3388 49.2528 34.5301 49.3485 34.7308 49.3861C34.9085 49.4194 35.0909 49.4194 35.2686 49.3861C35.4693 49.3485 35.6606 49.2528 36.0432 49.0615L64.1663 34.9999M5.83301 49.5832L33.9562 63.6448C34.3388 63.8361 34.5301 63.9318 34.7308 63.9694C34.9085 64.0028 35.0909 64.0028 35.2686 63.9694C35.4693 63.9318 35.6606 63.8361 36.0432 63.6448L64.1663 49.5832M5.83301 20.4166L33.9562 6.35499C34.3388 6.16368 34.5301 6.06803 34.7308 6.03038C34.9085 5.99704 35.0909 5.99704 35.2686 6.03038C35.4693 6.06803 35.6606 6.16368 36.0432 6.35499L64.1663 20.4166L36.0432 34.4782C35.6606 34.6695 35.4693 34.7651 35.2686 34.8028C35.0909 34.8361 34.9085 34.8361 34.7308 34.8028C34.5301 34.7651 34.3388 34.6695 33.9562 34.4782L5.83301 20.4166Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EF5350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2071 50.7929C74.5976 51.1834 74.5976 51.8166 74.2071 52.2071L67.2071 59.2071C66.8166 59.5976 66.1834 59.5976 65.7929 59.2071C65.4024 58.8166 65.4024 58.1834 65.7929 57.7929L72.7929 50.7929C73.1834 50.4023 73.8166 50.4023 74.2071 50.7929Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 44C67.5523 44 68 44.4477 68 45V47C68 47.5523 67.5523 48 67 48C66.4477 48 66 47.5523 66 47V45C66 44.4477 66.4477 44 67 44Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 62C73.5523 62 74 62.4477 74 63V65C74 65.5523 73.5523 66 73 66C72.4477 66 72 65.5523 72 65V63C72 62.4477 72.4477 62 73 62Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 51H62C62.5523 51 63 51.4477 63 52C63 52.5523 62.5523 53 62 53H60C59.4477 53 59 52.5523 59 52C59 51.4477 59.4477 51 60 51Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 58C77 57.4477 77.4477 57 78 57H80C80.5523 57 81 57.4477 81 58C81 58.5523 80.5523 59 80 59H78C77.4477 59 77 58.5523 77 58Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7929 45.7929C61.1834 45.4024 61.8166 45.4024 62.2071 45.7929L63.6213 47.2071C64.0118 47.5976 64.0118 48.2308 63.6213 48.6213C63.2308 49.0118 62.5976 49.0118 62.2071 48.6213L60.7929 47.2071C60.4024 46.8166 60.4024 46.1834 60.7929 45.7929Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3787 61.3786C76.7692 60.9881 77.4024 60.9881 77.7929 61.3786L79.2071 62.7928C79.5977 63.1833 79.5977 63.8165 79.2071 64.207C78.8166 64.5975 78.1834 64.5975 77.7929 64.207L76.3787 62.7928C75.9882 62.4023 75.9882 61.7691 76.3787 61.3786Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4142 46.5146C73.3669 44.562 76.5327 44.562 78.4853 46.5146C80.4379 48.4673 80.4379 51.6331 78.4853 53.5857L76.364 55.707C75.9735 56.0975 75.3403 56.0975 74.9498 55.707C74.5593 55.3165 74.5593 54.6833 74.9498 54.2928L77.0711 52.1715C78.2427 50.9999 78.2427 49.1004 77.0711 47.9288C75.8995 46.7573 74 46.7573 72.8285 47.9288L70.7071 50.0502C70.3166 50.4407 69.6835 50.4407 69.2929 50.0502C68.9024 49.6596 68.9024 49.0265 69.2929 48.636L71.4142 46.5146ZM65.0503 54.2928C65.4408 54.6833 65.4408 55.3165 65.0503 55.707L62.929 57.8283C61.7574 58.9999 61.7574 60.8994 62.929 62.071C64.1005 63.2426 66 63.2426 67.1716 62.071L69.2929 59.9497C69.6835 59.5591 70.3166 59.5591 70.7071 59.9497C71.0977 60.3402 71.0977 60.9733 70.7071 61.3639L68.5858 63.4852C66.6332 65.4378 63.4674 65.4378 61.5148 63.4852C59.5621 61.5326 59.5621 58.3667 61.5148 56.4141L63.6361 54.2928C64.0266 53.9023 64.6598 53.9023 65.0503 54.2928Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "white",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkUnavailable);
export default __webpack_public_path__ + "static/media/IconLinkUnavailable.09f2f376e67282d4a42d91719ce9f52e.svg";
export { ForwardRef as ReactComponent };